<!-- close button -->
<button class="pos-absolute top-0 right-0 z-10 p-a"
        type="button"
        [attr.aria-label]="'Close wishlist share modal window' | translate"
        sl-button="close"
        (click)="close()">
    <i class="icon-close"
       aria-hidden="true"></i>
</button>

<p class="p-b h3">{{ 'Share your wishlist' | translate }}</p>

<div class="w-12 m-t">
    @if(content?.components) {
    <icms-outlet [components]="content?.components!"></icms-outlet>
    }
</div>

<form #form="ngForm"
      method="POST"
      novalidate="true">

    <input-wrap [label]="'Your name' | translate">
        <input class="input"
               type="text"
               autocomplete="off"
               name="sender_name"
               [muiInput]="'Your name' | translate"
               [attr.placeholder]="'Press enter to confirm' | translate"
               required
               [(ngModel)]="data.sender_name">
    </input-wrap>

    <!-- Recipient Name -->
    <input-wrap class="w-12 m-t">
        <input class="input"
               type="text"
               autocomplete="off"
               name="recipient_name"
               [muiInput]="'Enter recipient name' | translate"
               [attr.placeholder]="'Press enter to confirm' | translate"
               required
               [(ngModel)]="data.recipient_name">
    </input-wrap>

    <!-- Email -->
    <input-wrap class="w-12 m-t">
        <input class="input"
               type="email"
               autocomplete="off"
               validatePattern="email"
               name="recipient_email"
               [muiInput]="'Enter email address' | translate"
               [attr.placeholder]="'Press enter to confirm' | translate"
               required
               [(ngModel)]="data.recipient_email">
    </input-wrap>

    <!-- Message -->
    <input-wrap class="w-12 m-t">
        <textarea class="textarea"
                  maxlength="300"
                  name="message"
                  autocomplete="off"
                  [muiInput]="'Enter message' | translate"
                  required
                  [(ngModel)]="data.message"></textarea>
    </input-wrap>

    <!-- submit -->
    <action class="w-4 button m-t"
            (click)="submit()"
            [status]="status">{{'Share Now' | translate}}
    </action>
    <result class="block m-t-1"
            [status]="status"
            [success]="'The message was sent' | translate"></result>
</form>